import { Box, Grid } from "@mui/material";
import guestsarrive from "../../../assets/images/guestsarrive.png";
import weddingceremony from "../../../assets/images/weddingceremony.png";
import cocktail from "../../../assets/images/cocktailhour.png";
import reception from "../../../assets/images/reception.png";
import afterparty from "../../../assets/images/afterparty.png";

const createCustomIcon = (image) => {
  return (
    <div style={{ position: "relative", width: "100%", height: "60px" }}>
      <img
        src={image}
        alt=""
        style={{
          position: "absolute",
          bottom: "10%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 150,
        }}
      />
    </div>
  );
};

const Section3Mobile = ({setOpen}) => {
  return (
    <Box
      style={{ padding: 20, backgroundColor: "#f2efeb" }}
      sx={{ flexGrow: 1 }}
    >
      <Grid
        container
        alignItems="center"
        style={{
          height: "100%",
          backgroundColor: "#f2efeb",
          // border: "solid #810605",
          borderRadius: 20,
          width: "100%",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <Grid
          item
          size={12}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <h1
            style={{
              fontFamily: "BrushScriptOpti-Regular",
              color: "#810605",
              fontSize: "7rem",
              transform: "rotate(-10deg)",
              margin: 0,
              fontWeight: 300,
            }}
          >
            Timeline
          </h1>
          <p></p>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
            fontFamily: "Montserrat",
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={guestsarrive} style={{ width: 150 }} />
          <div style={{ fontSize: "1rem", color: "#000" }}>4:30</div>
          <div style={{ color: "#810605", fontSize: "1.2rem" }}>
            GUESTS
            <br />
            ARRIVE
          </div>
          <div
            style={{
              color: "#810605",
              fontSize: ".9rem",
              fontWeight: 100,
              marginTop: 10,
              width: "80%",
            }}
          >
            Guests will arrive at the Oviatt Penthouse and then make their way
            to the rooftop to await the ceremony.
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
            fontFamily: "Montserrat",
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={weddingceremony} style={{ width: 150 }} />
          <div style={{ fontSize: "1rem", color: "#000" }}>5:00</div>
          <div style={{ color: "#810605", fontSize: "1.2rem" }}>
            WEDDING
            <br />
            CEREMONY
          </div>
          <div
            style={{
              color: "#810605",
              fontSize: ".9rem",
              fontWeight: 100,
              marginTop: 10,
              width: "80%",
            }}
          >
            The ceremony takes place, the bride and groom share their first
            kiss, and everyone rings a cowbell as we move inside for cocktail
            hour.
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
            fontFamily: "Montserrat",
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={cocktail} style={{ width: 150 }} />
          <div style={{ fontSize: "1rem", color: "#000" }}>6:00</div>
          <div style={{ color: "#810605", fontSize: "1.2rem" }}>
            COCKTAIL
            <br />
            HOUR
          </div>
          <div
            style={{
              color: "#810605",
              fontSize: ".9rem",
              fontWeight: 100,
              marginTop: 10,
              width: "80%",
            }}
          >
            Join us for cocktail hour with drinks and light bites before dinner,
            a perfect time to mingle and celebrate the happy couple!
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
            fontFamily: "Montserrat",
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={reception} style={{ width: 150 }} />
          <div style={{ fontSize: "1rem", color: "#000" }}>7:00</div>
          <div style={{ color: "#810605", fontSize: "1.2rem" }}>
            WEDDING <br />
            RECEPTION
          </div>
          <div
            style={{
              color: "#810605",
              fontSize: ".9rem",
              fontWeight: 100,
              marginTop: 10,
              width: "80%",
            }}
          >
            A formal dinner and dancing will follow on the rooftop. Enjoy
            dancing and all the special moments in between!
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            textAlign: "center",
            fontFamily: "Montserrat",
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 10,
          }}
        >
          <img src={afterparty} style={{ width: 150 }} />
          <div style={{ fontSize: "1rem", color: "#000" }}>10:00</div>
          <div style={{ color: "#810605", fontSize: "1.2rem" }}>
            AFTER
            <br />
            PARTY
          </div>
          <div
            style={{
              color: "#810605",
              fontSize: ".9rem",
              fontWeight: 100,
              marginTop: 10,
              width: "80%",
            }}
          >
            The wedding celebration will likely continue at Bar Clara (the bar
            at Hotel Per La).
          </div>
        </Grid>
         <Grid item size={12} style={{display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}}>
          <div style={{ height: 30 }} />
          <div
            style={{
            width: "50%",
              height: 30,
              border: "solid #810605",
              borderRadius: 15,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              marginTop: 20
            }}
          >
            <p style={{ fontFamily: "Montserrat", color: "#810605" }} onClick={() => setOpen(true)}>
              RSVP HERE
            </p>
          </div>
          <div style={{ height: 30 }} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Section3Mobile;
